import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {appData.title}
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed text-base">
              {appData.description}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-200 rounded-full text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                手机浏览器
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-200 rounded-full text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-tablet-line"></i>
                平板适配
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-200 rounded-full text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-cast-line"></i>
                投屏播放
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-200 rounded-full text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-picture-in-picture-line"></i>
                画中画
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-200 rounded-full text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-download-line"></i>
                离线缓存
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-64 h-80 rounded-xl overflow-hidden">
              <img
                src={appData.imageUrl}
                alt="爱丫爱丫影院移动追剧"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}